module.exports = __webpack_public_path__ + "img/logo_cockpit_small_color.05f55f24.svg";